import { Box } from '@quintoandar-tokko/jopijs';
import styles from './radioButtonsGroup.module.scss';
import ListGroup from './ListGroup';
import RadioButtonItem from './RadioButtonItem';

export default function RadioButtonsGroup({
  onClickRadio,
  selectedOption,
  allowedOptions,
  className = '',
}) {
  const list = allowedOptions.map((option) => ({
    id: option.id,
    text: option.text,
    checked: option.id === selectedOption,
  }));

  if (list.length > 2) {
    return <ListGroup list={list} onClickItem={onClickRadio} />;
  }

  return (
    <Box className={`${styles.radioButtonsGroup} ${className}`.trim()}>
      {list.map((item) => (
        <RadioButtonItem
          key={item.id}
          item={item}
          onClickRadio={onClickRadio}
        />
      ))}
    </Box>
  );
}
